
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2,0,0,2,0,0)"}},[_c('g',[_c('line',{staticStyle:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"},attrs:{"x1":"12","y1":"0.75","x2":"12","y2":"10.5"}}),_c('polyline',{staticStyle:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"},attrs:{"points":"8.75 7.5 12 10.5 15.25 7.5"}}),_c('polygon',{staticStyle:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"},attrs:{"points":"12 23.25 2 17.25 2 8.25 12 14.5 12 23.25"}}),_c('polygon',{staticStyle:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"},attrs:{"points":"22 17.25 12 23.25 12 14.5 22 8.25 22 17.25"}}),_c('polyline',{staticStyle:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"},attrs:{"points":"15.99 4.5 22 8.25 12 14.5 2 8.25 8 4.5"}})])])])
          )
        }
      }
    